module.exports = __webpack_public_path__ + "static/scale-model-of-san-antonio-texas-ff338ef246f6d6995e23f1b4048e3888.png";